"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = raf;

function raf(callback) {
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame(callback);
  }

  var nativeRaf = window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  return nativeRaf ? nativeRaf(callback) : window.setTimeout(callback, 1e3 / 60);
}